/**
 * Archivos de la computadora de proyección (solo dentro de la app KEORA Multimedia). Viven en una
 * carpeta de la propia computadora y no se suben al servidor; la app los sirve con keora-local://.
 */
export interface LocalFile {
  name: string;
  kind: 'image' | 'video' | 'audio';
  size: number;
}

interface LocalApi {
  folder: () => Promise<string>;
  list: () => Promise<LocalFile[]>;
  add: () => Promise<LocalFile[]>;
  remove: (name: string) => Promise<LocalFile[]>;
  /** Desde la versión 1.2.1 de la app. */
  rename?: (from: string, to: string) => Promise<LocalFile[]>;
  openFolder: () => Promise<void>;
}

type WithApp = Window & { keoraApp?: { local?: LocalApi } };

export const localApi = (): LocalApi | null => (typeof window !== 'undefined' ? ((window as WithApp).keoraApp?.local ?? null) : null);

export const localUrl = (name: string) => `keora-local://archivo/${encodeURIComponent(name)}`;

/** Miniaturas internas de EasyWorship («1-<GUID>.d=…w=1920.h=1080….jpg») que se copiaron al importar. */
export const isEwThumbnail = (name: string) => /\.d=\d+\.w=\d+\.h=\d+/i.test(name);
